export type WorkspaceRouteInformation = {
    workspaceId: string;
    workspaceName: string;
}

export function BuildQueryString(workspaceInfo: WorkspaceRouteInformation): string {
    return escape(workspaceInfo.workspaceId);
}
